import React from 'react';
import ReactDOM from 'react-dom';
import AuthenticationApp from './components/Authentication/AuthenticationApp';

const wrapper = document.getElementById('root-app');
ReactDOM.render(<AuthenticationApp/>, wrapper);
